import { render, staticRenderFns } from "./audience.schedule.vue?vue&type=template&id=18c6bca0&lang=pug"
import script from "./audience.schedule.vue?vue&type=script&lang=js"
export * from "./audience.schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports